import { put } from "@redux-saga/core/effects";
import { useSelector } from "react-redux";
import { all, takeEvery,  call } from 'redux-saga/effects'
// import { toast } from 'react-toastify';
// import { clientListing } from "../../services/clientListingServices";
import { gettaloadresponse } from "../../services/gettaloadservices";
// import { getbalancerequest, getbalancesuccess, getbalancefailure } from "./action";
import { gettaloadrequest,gettaloadsuccess,gettaloadfailure } from "./action";
import { GET_TALOAD } from "./types";

export function* gettaload(data){
    yield put(gettaloadrequest())
    try{
        


        const result = yield call(gettaloadresponse);
        
        // if (result.status == "ACTIVE") {

            yield put(gettaloadsuccess(result));
            // toast.success(" Successfully")
        // } else {

            yield put(gettaloadfailure(result))
            // toast("FailListing")
        // }

    }
    catch(error){

        // yield put(getbalancefailure(error.response.data))

        // toast.error("Validation Error listing")

    }

}

export default function* GettaloadlistSaga() {
   
    yield all([takeEvery(GET_TALOAD, gettaload)])
}
